import { render, staticRenderFns } from "./BaseSet.vue?vue&type=template&id=db13011a&scoped=true"
import script from "./BaseSet.vue?vue&type=script&lang=js"
export * from "./BaseSet.vue?vue&type=script&lang=js"
import style0 from "./BaseSet.vue?vue&type=style&index=0&id=db13011a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db13011a",
  null
  
)

export default component.exports